import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNudgeCongrats = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99967 1.33325L10.0597 5.50659L14.6663 6.17992L11.333 9.42659L12.1197 14.0133L7.99967 11.8466L3.87967 14.0133L4.66634 9.42659L1.33301 6.17992L5.93967 5.50659L7.99967 1.33325Z",
		stroke: "#3ABF87",
		strokeWidth: 1.6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgNudgeCongrats;
